import React, { useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import TablePagination from "@material-ui/core/TablePagination";
import TableSortLabel from '@material-ui/core/TableSortLabel';
import BTN from "../Button/Button";
import DeleteIcon from "../../CVs/CommercialCPs/ListOfCvs/DeleteIcon";
import { AddToPhotosRounded, LaunchRounded } from "@material-ui/icons";
import { createSortHandler, getComparator, stableSort } from "../../CVs/utils";
import classes from './MUITable.module.css'
import commonClasses from '../../CVs/CVs.module.css'
import { TablePaginationActions } from "./TablePagination";

const TableUI = (props) => {
    const rows = props.data.rows;
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('name');

    const handleChangePage = (event, newPage) => {
        props.setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        props.setRowsPerPage(parseInt(event.target.value, 10));
        props.setPage(0);
    };

    useEffect(() => {
        if (props.rechargeData) {
            props.setPage(0)
        }
    }, [props.rechargeData])

    return (
        <Paper className={commonClasses.root}>
            <TableContainer className={classes.container}>
                <Table size={"small"} stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {props.data.columns.map((column) => (
                                column.visibility ?
                                    <TableCell
                                        width={column.width}
                                        key={column.id}
                                        sortDirection={orderBy === column.id ? order : false}
                                    >
                                        <TableSortLabel
                                            active={orderBy === column.id}
                                            direction={orderBy === column.id ? order : 'asc'}
                                            onClick={createSortHandler(column.id, setOrder, setOrderBy, orderBy, order)}>
                                            {column.label}
                                            {orderBy === column.id ? (
                                                <span className={commonClasses.visuallyHidden}>
                                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                                </span>
                                            ) : null}
                                        </TableSortLabel>
                                    </TableCell> : ""
                            ))}
                            <TableCell width='300px'> </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {stableSort(rows, getComparator(order, orderBy)).slice(props.page * props.rowsPerPage, props.page * props.rowsPerPage + props.rowsPerPage).map((row, index) => {
                            return <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                {props.data.columns.map((column, index) => {
                                    return column.visibility &&
                                        <TableCell style={{ width: column.width, wordBreak: 'break-word' }} key={index} onClick={props.clickRow(row, column)}>
                                            {column.field === "" ? null : row[column.field]}
                                        </TableCell>
                                })}
                                <TableCell key="newCommercialCP" style={{ padding: 0, width: '200px', margin: 0 }}>
                                    <div className={commonClasses.actions}>
                                        <BTN label="NEW COMMERCIAL CP"
                                            variant="success"
                                            isVisible={props.isNewCommercialBtnVisible(row) && (props.isAdminMember || props.isSalesMember)}
                                            size="sm"
                                            actionHandler={props.clickRow(row, {
                                                label: "",
                                                field: "",
                                                id: "",
                                                sort: "",
                                                visibility: true
                                            })}
                                            style={{ width: "auto", marginLeft: "15px" }} tooltip={`New Commercial Consultant Profile`}
                                            icon={<AddToPhotosRounded />}
                                            smallScreenThreshold={"66rem"}
                                        />
                                        <BTN label="OPEN"
                                            variant="success"
                                            isVisible={true}
                                            size="sm"
                                            actionHandler={props.clickRow(row, {
                                                label: "Modification Date",
                                                field: "modificationDate",
                                                id: "modificationDate",
                                                sort: "asc",
                                                visibility: true
                                            })}
                                            style={{ width: "auto", marginLeft: "1%" }} tooltip={`OPEN Consultant Profile`}
                                            icon={<LaunchRounded />}
                                            smallScreenThreshold={"66rem"}
                                        />
                                        {props.isAdminMember &&
                                            <DeleteIcon element={"Consultant Profile"}
                                                elementName={row.name}
                                                delete={() => props.deleteCP(row.id)}
                                            />}
                                    </div>
                                </TableCell>
                            </TableRow>
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[25, 50, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={props.rowsPerPage}
                page={props.page}
                SelectProps={{
                    inputProps: { 'aria-label': 'rows per page' },
                    native: true,
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
            />

        </Paper>
    );
};

export default TableUI;